module.exports = __webpack_public_path__ + "24_pvis1.jpg?3e79c1c710e42c3b31bf59f2c1d9ed9b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_pvis1.jpg
// module id = 211
// module chunks = 0